/* asynckit/serial */ function _(require, module, exports) {
    var serialOrdered = require(61) /* ./serialOrdered.js */;
    // Public API
    module.exports = serial;
    /**
     * Runs iterator over provided array elements in series
     *
     * @param   {array|object} list - array or object (named list) to iterate over
     * @param   {function} iterator - iterator to run
     * @param   {function} callback - invoked when all elements processed
     * @returns {function} - jobs terminator
     */
    function serial(list, iterator, callback) {
        return serialOrdered(list, iterator, null, callback);
    }
}
